import React from 'react';
import PropTypes from 'prop-types';
import { defaultTemplate } from 'core/hoc';
import { BaasicButton, BasicCheckbox } from 'core/components';

function FacilityOrderNewFlowRoundingItemsModalTemplate({ facilityOrderNewFlowRoundingItemsModalStore, t }) {
    const {
        roundItems,
        isLoading,
        modalParams,
        items,
        setIncludeItem
    } = facilityOrderNewFlowRoundingItemsModalStore;
    return (
        <section>
            <div className={!modalParams.data.approvalRequired ? 'modal__body type--center' : 'modal__wrap'}>
                <i className="status--sqare modal-warning u-mar--bottom--med u-radius--full" />
                <p className='modal__header__title'>{items ? "There are less than 4 patients using the following item(s). Check off the item to round down anyway." : "There are less than 4 patients using this item. Do you want to round down anyway?"}</p>

                {modalParams.data.approvalRequired &&
                    <p className='type--base u-padd--right--med u-mar--top--med type--color--secondary'>
                        {t('MODAL.PROCESS_MESSAGE_APPROVAL')}
                    </p>
                }
            </div>
            {items && <div className="modal__body">
                <div className="u-mar--top--lrg">
                    <table className="table--preview">
                        <thead>
                            <tr>
                                <th width="8%" className="type--center">Round</th>
                                <th width="20%" className="type--left">Item ID</th>
                                <th width="*" className="type--left">Item Name</th>
                                <th width="20%" className="type--left">Number of patients</th>
                            </tr>
                        </thead>
                        <tbody>
                            {items && items.map((item) => {
                                return (
                                    <tr key={item.productId}>
                                        <td className="type--center"><BasicCheckbox className='input--check input--check--no-label' id={item.productId} checked={item.includeItem} onChange={() => setIncludeItem(item)} disabled={isLoading} /></td>
                                        <td>{item.itemId}</td>
                                        <td>{item.itemName}</td>
                                        <td>{item.patientCount}</td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
            </div>}
            <div className={!modalParams.data.approvalRequired ? 'modal__footer is-right' : 'modal__footer is-right'}>
                <BaasicButton
                    className='btn btn--med btn--light'
                    label={items ? "Cancel" : "No"}
                    disabled={isLoading}
                    onClick={() => modalParams.close()}
                />
                <BaasicButton
                    className='btn btn--med btn--primary'
                    label={items ? "Confirm" : "Yes"}
                    disabled={isLoading}
                    onClick={async () => await roundItems()}
                    rotate icon={
                        isLoading
                            ? "u-icon u-icon--xmed u-icon--sync u-rotate--login"
                            : 'u-display--none'
                    }
                />
            </div>
        </section>
    )
}

FacilityOrderNewFlowRoundingItemsModalTemplate.propTypes = {
    facilityOrderNewFlowRoundingItemsModalStore: PropTypes.object,
    t: PropTypes.func
};

export default defaultTemplate(FacilityOrderNewFlowRoundingItemsModalTemplate);
